import React, { useMemo } from "react";
import { WhoPaysOption, whoPaysLabels } from "@common/types/filters/clients";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const WhoPaysFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const activeOrganization = useActiveOrganization();
    const orgName = activeOrganization?.name ?? "My firm";

    const options = useMemo(
        (): FilterMultiselectOption[] => [
            {
                value: WhoPaysOption.CLIENT,
                label: whoPaysLabels[WhoPaysOption.CLIENT],
                searchableLabel: whoPaysLabels[WhoPaysOption.CLIENT],
            },
            {
                value: WhoPaysOption.ORGANIZATION,
                label: orgName,
                searchableLabel: orgName,
            },
            {
                value: WhoPaysOption.OTHER_FIRM,
                label: whoPaysLabels[WhoPaysOption.OTHER_FIRM],
                searchableLabel: whoPaysLabels[WhoPaysOption.OTHER_FIRM],
            },
        ],
        [orgName],
    );

    const value = filters.whoPays ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    onChange({
                        whoPays:
                            val.length > 0
                                ? (val as WhoPaysOption[])
                                : undefined,
                    });
                }}
                name="whoPays"
                onBlur={noop}
            />
        </div>
    );
};
